<template>
  <div class="main-nav">

    <router-link
      :to="'/'"
      @click.native="hideMainnav()"
      >
      {{lg('',{
        en: 'HOME',
        zh: '主页',
      })}}
    </router-link>

    <router-link
      :to="{name: 'explore'}"
      @click.native="hideMainnav()"
      >
      {{lg('',{
        en: 'Explore',
        zh: '淘狮子',
      })}}
    </router-link>

    <router-link
      :to="{name: 'breeding'}"
      @click.native="hideMainnav()"
      >
      {{lg('',{
        en: 'Breed',
        zh: '繁殖',
      })}}
    </router-link>

    <router-link
      :to="{name: 'race_list'}"
      @click.native="hideMainnav()"
      >
      {{lg('',{
        en: 'Battle',
        zh: '战斗',
      })}}
    </router-link>

    <router-link
      :to="{name: 'my'}"
      @click.native="hideMainnav()"
      >
      {{lg('',{
        en: 'My Collection',
        zh: '我的收藏',
      })}}
    </router-link>

    <!-- <router-link
      :to="{name: 'more'}"
      @click.native="hideMainnav()"
      >
      {{lg('',{
        en: 'More',
        zh: '',
      })}}
    </router-link> -->

    <a
      style="color: var(--link-color);"
      >
      {{lg('',{
        en: 'More',
        zh: '更多',
      })}}
    </a>

    <!-- <router-link
      :to="'/race'"
      @click.native="hideMainnav()"
      >
      {{lg('',{
        en: 'RACE',
        zh: '',
      })}}
    </router-link> -->

    <!-- <router-link
      :to="{name: 'breeding'}"
      @click.native="hideMainnav()"
      >
      {{lg('',{
        en: 'BREEDING',
        zh: '',
      })}}
    </router-link> -->

    <!-- <a>
      Contact
    </a> -->

    <!-- <a 
      :href="`https://info.xxx.com`" 
      target="_blank" 
      class="d-block ml-5" 
      @click="hideMainnav()">
      {{lg('',{
        en: 'xxx',
        zh: '外部链接',
      })}}
    </a> -->

  </div>
</template>

<script>
import bus from '@/bus.js'

export default {
  name: 'mainnav',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    hideMainnav(){
      // console.log(bus.topnavvue)
      bus.topnavvue.dropnavOpen = false
    },
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .main-nav{
    a{
      margin-left: 40px;;
    }
  }
  @media(max-width: 789px){
    .main-nav{
      a{
        display: block;
      }
    }
  }
</style>